const settings = {
    API_ROOT: `${
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_ENDPOINT
            : process.env.REACT_APP_PROD_ENDPOINT
    }/api/`,
}

console.log("endpoint", process.env.REACT_APP_DEV_ENDPOINT)
export default settings



// WEBPACK FOOTER //
// ./src/app/settings.js